module.exports = __webpack_public_path__ + "static/media/components-icon.4b99aad1.svg";